module.exports = __webpack_public_path__ + "static/media/YM73_2.a1f40c3c.jpg";